import { render, staticRenderFns } from "./SupplierView.vue?vue&type=template&id=680c0abf&scoped=true"
import script from "./SupplierView.vue?vue&type=script&lang=js"
export * from "./SupplierView.vue?vue&type=script&lang=js"
import style0 from "./SupplierView.vue?vue&type=style&index=0&id=680c0abf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680c0abf",
  null
  
)

export default component.exports